import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

const { Put } = axiosInstanceApiGateway

export type PutUpdateDisbursmentV2RequestType = {
  disbursmentID: number
  data: {
    disbursement_id: number
    status: string
    target_type: string
    target_channel: string
    target_identifier: string
    target_account_name: string
  }
}

export type PutUpdateDisbursmentV2ResponseType = {
  data: {
    message: 'success'
  }
  error: {
    message: ''
    status: false
    code: 0
  }
}

export type PutBulkUpdateDisbursementV2RequestType = {
  data: {
    disbursements: {
      disbursement_id: number
      status: string
    }[]
    request_id: string
    source: string
  }
}

export type PutBulkUpdateDisbursementV2ResponseType = {
  data: {
    success_ids: number[]
    failed_ids: number[]
    message: string
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export const putUpdateDisbursmentV2 = ({
  disbursmentID,
  data,
}: PutUpdateDisbursmentV2RequestType) =>
  Put<PutUpdateDisbursmentV2ResponseType>({
    url: '/payment/internal/v1/disbursement/:id',
    urlParams: { id: disbursmentID },
    data,
  })

export const putBulkUpdateDisbursementV2 = ({ data }: PutBulkUpdateDisbursementV2RequestType) =>
  Put<PutBulkUpdateDisbursementV2ResponseType, true>({
    url: '/payment/internal/v1/disbursement/bulk',
    data,
  })
